export default __webpack_public_path__ + "static/media/webopensmall.ff897b1d.png";